import {
  ConnectionState,
  Notification,
} from "@/models/notification/Notifications";
import { createContext, useContext } from "react";

export type NotificationHubContextProps = {
  notifications: Notification[];
  setNotifications: (notifications: Notification[]) => void;
  allNotifications: Notification[];
  setAllNotifications: (notifications: Notification[]) => void;
  totalNotificationCount: number;
  activeCount: number;
  connectionState: ConnectionState;
  isLoading: boolean;
  // error: string | null;
  // refetch: () => Promise<void>;
  manualReconnect: () => Promise<void>;
  seeAllNotifications: () => Promise<void>;
  seeNotifications: (notificationIds: string[]) => Promise<void>;
  isMarkingAsSeen: boolean;
  dismissAllNotifications: () => Promise<void>;
  dismissNotification: (notificationId: string) => Promise<void>;
  dismissNotifications: (notificationIds: string[]) => Promise<void>;
  isDismissingAllNotifications: boolean;
  isDismissingNotification: Record<string, boolean> | undefined;
  deleteNotifications: (notificationIds: string[]) => Promise<void>;
  deleteAllNotifications: () => Promise<void>;
  isDeletingNotifications: boolean;
  isDeletingAllNotifications: boolean;
  checkedNotifications: string[];
  setCheckedNotifications: (checkedNotifications: string[]) => void;
  // Infinite scrolling
  loadMoreAllNotifications: () => Promise<void>;
  loadMoreActiveNotifications: () => Promise<void>;
  hasMoreAll: boolean;
  hasMoreActive: boolean;
  isLoadingAllNotifications: boolean;
  isLoadingMoreAll: boolean;
  isLoadingMoreActive: boolean;
  // Page-based navigation (used by NotificationsWidget)
  allNotificationsCurrentPage: number;
  allNotificationsTotalPages: number;
  goToAllNotificationsPage: (page: number) => void;
};

export const NotificationContext =
  createContext<NotificationHubContextProps | null>(null);
export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotificationContext must be used within NotificationHubProvider"
    );
  }
  return context;
};
